import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "./Dashboard.css";
import MainLayout from "../mainlayout/MainLayout";
import Sidebar from "../sidebar/Sidebar";
import Modal from "../modal/Modal";
import ViewTask from "../modal/ViewTask";

import { Menu } from "lucide-react";
import Common from "../common/Common";

const Dashboard = () => {
  const [tasks, setTasks] = useState([]);
  const [task,setTask] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  const handleDateClick = (info) => {
    setSelectedDate(info.dateStr);
    setIsModalOpen(true);
  };

const handleCloseModal = () => {
  setIsModalOpen1(false);
};

  const handleDatesSet = async (arg) => {
    let response = await fetch(`${process.env.REACT_APP_NODEURL}/getTask`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        start: arg.startStr,
        end: arg.endStr,
      }),
    });

    let ans = await response.json();
    if (ans.msg === "success") {
      let tasks = [];
      if (ans.res.length > 0) {
        ans.res.map((item) => {
          let color = Common();
          const newTask = {
            id:item._id,
            title: item.tasks,
            start: item.startTime,
            end: item.endTime,
            status:item.status,
            resources:item.resources,
            backgroundColor: color,
            textColor: "black",
          };
          tasks.push(newTask);
        });
        setTasks(tasks);
      }
    }
  };

  const toggleSidebar = () => {
    setSidebarVisible((prev) => !prev);
  };
  
  const viewTask = (info)=>  {
    let {status,resources} = info.event._def.extendedProps
    let task = {
      task:info.event.title,
      id:info.event.id,
      status:status,
      resources:resources,
      startTime:info.event.start,
      endTime:info.event.end
    }
    setTask(task)
    setIsModalOpen1(true)
  }

  const updateTaskInState = (updatedTask,del) => {
    if(del==true){
       setTasks(prev => prev.filter(task => task.id !== updatedTask));
    }
    else if(del==false){
      setTasks((prev) =>
      prev.map((task) =>
        task.id === updatedTask._id ? { ...task, ...updatedTask } : task
      )
    );
    }
    
    
  };

  


  return (
   <>

      {/* Main Content */}
      <MainLayout>
        {/* Quote */}
        <div className="relative flex justify-center items-center mb-6">
          <p className="text-base sm:text-sm md:text-md lg:text-lg xl:text-xl font-bold absolute left-1/2 transform -translate-x-1/2">
            The best way to predict the future is to create it.
          </p>
        </div>

        {/* Calendar Section */}
        <div className="p-6 text-center text-grey rounded-lg shadow-lg">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            events={tasks}
            height="auto"
            eventDisplay="block"
            eventTextColor="#fff"
            eventBorderColor="transparent"
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            eventClick={viewTask}
            dateClick={handleDateClick}
            datesSet={handleDatesSet}
            dayHeaderClassNames="bg-gray-900"
          />

          {/* Modal for Task Creation */}
          <Modal
            isOpen={isModalOpen}
            onSave={(newTask) => {
              console.log(newTask)
              setTasks([...tasks, newTask]);
              setIsModalOpen(false);
            }}
            onClose={() => setIsModalOpen(false)}
            selectedDate={selectedDate}
          />
          <ViewTask
            isOpen={isModalOpen1}
            isPlan={""}
            task={task} onClose={handleCloseModal} onSave={updateTaskInState}
          />
        </div>
        </MainLayout>
        </>
  );
};

export default Dashboard;
